import React, { useEffect, useCallback, useState} from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {connect} from 'react-redux';

const Simplifier = ({instrument, setMods}) => { 
    let [percentage, setPercentage] = useState(50);
    let [stats, setStats] = useState(instrument.getStats());

    const onClick = useCallback(() => {
        instrument.simplifyPatch(percentage);
        let stats = instrument.getStats();
        setStats(stats);
        setMods(stats);
    }, [setStats, instrument, percentage, setMods]);

    return (
        <div className="simplifier">
          <div className="stats">
            {stats} modulations
          </div>
          <div className="slider-and-btn">
          <ReactBootstrapSlider
            value={percentage}
            change={(e) => setPercentage(e.target.value)}
            step={1}
            max={100}
            min={0}
            orientation="horizontal"
            reversed={false}
          />
          <div
            onClick={onClick}
            className="simplify-btn">
            Simplify Patch ({percentage}%)
          </div>
          </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Simplifier);
